import {AbstractControl, Form, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function feedbackSeverityValidator(fg: FormGroup): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const feedbackTypeControl = fg.get('feedbackType');
    if (feedbackTypeControl) {
      const feedbackType = feedbackTypeControl.value;
      if (feedbackType != "Feedback") {
        return null;
      } else {
        if (control.value != "Unknown") {
          return null;
        }
        return {"FeedbackSeverityMustBeSet": true};
      }
    }
    return null;
  }
}
